import { get, post, del, put } from '@api/request';

export const fetchNoticeDefaultConfig = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/pdfeventsdefaultconfig`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAllAppraisalNoticeRun = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotices`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const exportAppraisalNoticeRun = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/export`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const exportFileDownloadAppraisalNoticeRun = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID, s3ID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/export/file/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const fetchAllAppraisalNoticeConfig = async (
  { appraisalNoticeService },
  authenticationToken,
  { pYear = null } = {},
) => {
  const params = pYear ? `?pYear=${pYear}` : '';
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfigurations${params}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertAppraisalNoticeConfig = async (
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfigurations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchAppraisalNoticeConfig = async (
  { appraisalNoticeService },
  authenticationToken,
  { configID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfiguration/${configID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateAppraisalNoticeConfig = async (
  { appraisalNoticeService },
  authenticationToken,
  { configID, payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfiguration/${configID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteAppraisalNoticeConfig = async (
  { appraisalNoticeService },
  authenticationToken,
  { configID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfiguration/${configID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const validateQuery = async (
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const createAppraisalNoticeRun = async (
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotices`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteAppraisalNoticeRun = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchAllAppraisalNoticeConfigTaxingUnit = async (
  { appraisalNoticeService },
  authenticationToken,
  { pYear },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfiguration/taxingunits?pYear=${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitsSummary = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunitssummary`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertAppraisalNoticeConfigTaxingUnit = async (
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfiguration/taxingunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteAppraisalNoticeConfigTaxingUnit = async (
  { appraisalNoticeService },
  authenticationToken,
  { configID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnoticeconfiguration/taxingunit/${configID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchAllAppraisalNoticeSubmissions = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/capturesubmissionvalues`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAppraisalNoticeSubmission = async (
  { appraisalNoticeService },
  authenticationToken,
  { logId },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/capturesubmissionvalue/${logId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createAppraisalNoticeSubmissionRun = async (
  { appraisalNoticeService },
  authenticationToken,
  { payload, pYear = new Date().getFullYear() },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/capturesubmissionvalues/${pYear}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchFolders = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/s3folders`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchImports = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/import`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const importNotice = async (
  { appraisalNoticeService },
  authenticationToken,
  payload,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/import`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchEventTypes = async (
  { eventService },
  authenticationToken,
) => {
  const url = `${eventService}/events/peventforms`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchMassCreateCompGrids = async (
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 200 } = {},
) => {
  const url = `${appraisalService}/appraisal/comparables/masscreategrids?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchMassCreateCompGrid = async (
  { appraisalService },
  authenticationToken,
  { massCreateGridID },
) => {
  const url = `${appraisalService}/appraisal/comparables/masscreategrid/${massCreateGridID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createMassCreateCompGrids = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/comparables/masscreategrids`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const removeRunTags = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID, payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/removetags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const createPdfEvents = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID, payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/createpdfevents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const canCreateEDRNotifications = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/cancreateedrnotifications`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createEDRNotifications = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/createedrnotifications`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const lockProperty = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/lockproperty`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const checkLiveRun = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID, payload },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/liverun`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchImportMassFiles = async (
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 50 },
) => {
  const url = `${appraisalService}/import/massfile?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const importMassFiles = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/import/massfile`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const generatePreSignedURL = async (
  { appraisalService },
  authenticationToken,
  { file },
) => {
  const url = `${appraisalService}/import/generatepresignedurl/${file}`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const fetchMassFileDetails = async (
  { appraisalService },
  authenticationToken,
  { massFileImportID, page = 1, pageSize = 50, errorsOnly = 0 },
) => {
  const url = `${appraisalService}/import/massfile/${massFileImportID}/details?page=${page}&pageSize=${pageSize}&errorsOnly=${errorsOnly}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAppraisalNoticeProperties = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID, page = 0, pageSize = 50, pID },
) => {
  const pidParam = pID ? `&pID=${pID}` : '';
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/property?page=${page}&pageSize=${pageSize}${pidParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAppraisalNoticeTaxingUnits = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID, page = 0, pageSize = 50, pID },
) => {
  const pidParam = pID ? `&pID=${pID}` : '';
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/propertytaxingunit?page=${page}&pageSize=${pageSize}${pidParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAppraisalNoticeExemptions = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeID, page = 0, pageSize = 50, pID },
) => {
  const pidParam = pID ? `&pID=${pID}` : '';
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeID}/propertyexemption?page=${page}&pageSize=${pageSize}${pidParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicDeliveryRecords = async (
  { appraisalNoticeService },
  authenticationToken,
  { noticeId, params },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/appraisalnotice/${noticeId}/electronicdelivery?${params}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPortalNotificationRuns = async (
  { appraisalNoticeService },
  authenticationToken,
  { params },
) => {
  const { page = 1, pageSize = 20 } = params;
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotificationruns?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPendingPortalNotifications = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotificationrun/pending`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createPortalNotificationRun = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotificationruns`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const fetchPortalNotificationEmailConfig = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/emailconfiguration`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updatePortalNotificationEmailConfig = async (
  { appraisalNoticeService },
  authenticationToken,
  payload,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/emailconfiguration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const previewPortalNotificationEmail = async (
  { appraisalNoticeService },
  authenticationToken,
  notificationId,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/${notificationId}/previewemail`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPortalNotificationRecords = async (
  { appraisalNoticeService },
  authenticationToken,
  { runId, page = 1, pageSize = 10, filter },
) => {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotificationrun/${runId}/details?page=${page}&pageSize=${pageSize}`;
  if (filter) {
    url += `&filter=${filter}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPortalNotificationAgentEmailConfig = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/agentemailconfiguration`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updatePortalNotificationAgentEmailConfig = async (
  { appraisalNoticeService },
  authenticationToken,
  payload,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/agentemailconfiguration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};
